import { createContext, useContext } from 'react';

import { CatalogFieldDetails, CatalogQuery } from 'modules/domains';

import { CatalogQueryDetailsAngular } from '../domain';

export type DataReturnedToAngular = {
  catalogQuery: CatalogQuery | null;
  catalogFieldDetails?: CatalogFieldDetails;
};
export type ReturnDataToAngularFn = (value: DataReturnedToAngular) => void;

type AngularCatalogQueryContext = {
  catalogQueryDetails?: CatalogQueryDetailsAngular;
  saveAndClose: ReturnDataToAngularFn;
};

export const AngularCatalogQueryContext = createContext<AngularCatalogQueryContext>({
  saveAndClose: () => null,
});

export const useAngularCatalogQueryContext = () => useContext(AngularCatalogQueryContext);
